import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { Button } from 'primereact/button'

import { Header } from '../../../../components/Header'
import { useConfigContext } from '../../../ui-config/context'
import { AcceptContainer } from './dialogs/Accept'
import { Reject } from './dialogs/Reject'

type Props = {
  id: string
  orderId?: string
  isLoading: boolean
}

export const Title: React.FC<Props> = ({ id, orderId, isLoading }) => {
  const { uiConfig: config } = useConfigContext()
  const navigate = useNavigate()

  const [displayRejectOrder, setDisplayRejectOrder] = useState(false)

  const { t } = useTranslation()

  const actions = (
    <>
      <Button
        label={t('despatchAdvice.title.history.label')}
        className="p-button-text"
        onClick={() => navigate(`/orders/history?search=${orderId}`)}
      />

      <Button
        label={t(`common.buttons.reject`)}
        icon="pi pi-times"
        className="p-button-outlined"
        onClick={() => setDisplayRejectOrder(true)}
        visible={config.despatchAdvice.rejectDespatchAdvice.enabled !== false}
      />

      <Reject
        visible={displayRejectOrder}
        setVisible={setDisplayRejectOrder}
        id={id}
      />

      <AcceptContainer id={id} />
    </>
  )

  return (
    <Header
      title={t('despatchAdvice.title.title', {
        orderId: orderId,
      })}
      showBackButton={true}
      showPrintButton={true}
      actions={actions}
      isLoading={isLoading}
    />
  )
}
